import { render } from "./TicketBlock.vue?vue&type=template&id=242341c3"
import script from "./TicketBlock.vue?vue&type=script&lang=js"
export * from "./TicketBlock.vue?vue&type=script&lang=js"

import "./TicketBlock.vue?vue&type=style&index=0&id=242341c3&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__